import moment from "moment";
import { model } from "eco-cli";
const Image = model.Image;
const User = model.UserInfo;
const File = model.File

export class Article {
    static blank() {
        return new this({});
    }

    constructor(json) {
        Object.assign(this, json);
    }

    static test() {
        return new Article({
            id: Math.random(),
            title: "测试文章" + Math.random(),
        });
    }

    static fromServer(json) {
        return new Article({
            id: json.id,
            title: json.title || "",
            publishDate: moment(json.createTime),
            content: json.html || "",
            viewCount: json.scanCount,
            replyCount: json.respCount,
            type: json.type,
            isHot: json.isHot,
            isNew: json.isNew,
            status: json.status,
            typeName: json.typeName,
            author: User.new({
                uid: json.createBy,
                avatar: Image.avatar(json.avatar),
                nickname: json.nickname,
                isExpert: json.isExpert
            }),
            discussName: json.discussName,
            replyDate: moment(json.respTime),
            isSolve: json.isSolve === '0' ? false : true,
            fileList: json.fileList ? (json.fileList.map((v) => File.fromServer(v))) : [],
            editContent: json.content || ""
        });
    }
    toServer() {
        return {
            title: this.title,
            type: this.type,
            status: this.status,
            html: this.html,
            fileList: this.fileList,
            id: this.id,
            content: this.content
        };
    }

    id = "";
    title = "";
    content = "";
    author = User.blank();
    publishDate = moment();
    viewCount = 0;
    replyCount = 0;
    type = "";
    isHot = false;
    isNew = false;
    typeName = "";
    discussName = "";
    replyDate = moment();
    isSolve = false;
    fileList = [];
    status = '0';
    html = '';
    editContent = ''
}

export class Author extends model.Model {
    info = User.blank();
    questionNum = 0;
    discussNum = 0;
    expertCompany = '';
    expertPosition = '';
    static blank() {
        return new this({});
    }
    static fromServer(json) {
        return Author.new({
            info: User.fromServer(json),
            questionNum: json.questionNum || 0,
            discussNum: json.discussNum || 0,
            expertCompany: json.expertCompany || '',
            expertPosition: json.expertPosition || ''
        })
    }
}


export class Question extends Article {

    isQuestion = true

    static fromServer(json) {
        console.log(111, Object.assign(new Question(), Article.fromServer(json)))
        return Object.assign(new Question(), Article.fromServer(json))
    }
}

export class TrainArticle extends Article {
    isTrainArticle = true
    static fromServer(json) {
        console.log(111, Object.assign(new TrainArticle(), Article.fromServer(json)))
        return Object.assign(new TrainArticle(), Article.fromServer(json))
    }
}

export class ShareArticle extends Article {
    isShareArticle = true
    static fromServer(json) {
        console.log(111, Object.assign(new ShareArticle(), Article.fromServer(json)))
        return Object.assign(new ShareArticle(), Article.fromServer(json))
    }
}